import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPointerRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 153 129",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M0 74.55L113.38 74.55L74.02 113.92L88.59 128.5L152.84 64.25L88.59 0L74.02 14.57L113.38 53.94L0 53.94L0 74.55L0 74.55Z",
		fill: "currentColor"
	}) })
});
export { SvgPointerRight as ReactComponent };
